import actions from './actions'
import types from './constants'
import {fetchParentReport} from "../../services/parent/index";


const fetchReport = (...args) => (dispatch) => {
  dispatch(actions[types.PARENT_PENDING]())
  fetchParentReport(...args)
  .then(async (report) => {
    dispatch(actions[types.PARENT_COMPLETE](report))
  })
  .catch((e) => {
    console.log("ERROR:",e)
    dispatch(actions[types.PARENT_ERROR](e.message))
  })
}

export default {
  fetchReport
}
